import { PaymentScheduleType } from './DealInvoice';
import { State } from './Lookups';
import { SubscriptionFrequency, SuccessFeeTier } from './Product';
import { SuccessFeeType } from './ProductSubscription';

export interface CompanySubscription {
	id: number;
	guid: string;
	companyGuid: string;
	term: number;
	guaranteeTerms: number;
	dealsPerYear: number;
	dealsThisYear: number;
	isNextAdditionalDeal: boolean;
	autoRenew: boolean;
	subscriptionFee: number;
	firstYearSubscriptionFee: number | null;
	subscriptionFeePaymentSchedule: PaymentScheduleType;
	additionalDealFee: number;
	additionalDealFeePaymentSchedule: PaymentScheduleType;
	successFeePaymentSchedule: PaymentScheduleType;
	startDate: string | null;
	nextBillingDate: string | null;
	subscriptionEndDate: string | null;
	cancellationDate: string | null;
	cancellationFee: number | null;
	billingFrequency: SubscriptionFrequency;
	successFeeType: SuccessFeeType;
	basisPoints: number | null;
	reducedFeeLenderDiscountPercent: number | null;
	minimumSuccessFee: number | null;
	agreementSignedBy: string;
	agreementSignedDate: string | null;
	agreementFileName: string;
	contractFileName: string;
	createdOn: Date;
	modifiedOn: Date;
	isCancelled: boolean;
	billingFeeAmount: number;
	shouldCancel: boolean;
	refinanceBenefitAmount: number;
	companyName: string;
	city: string;
	postalCode: string;
	state: State | null;
	address1: string;
	refinanceSuccessFeeDiscount: number | null;
	refinanceBenefitType: RefinanceBenefitType | null;
	dealStatus: CompanySubscriptionStatus;
	accountManager: string;
	excludedLendersCount: number;
	reducedFeeLendersCount: number;
	successFeeTiers: SuccessFeeTier[];
	paymentTerms: SubscriptionPaymentTerm[];
	paymentTermsComplete: boolean;
	hasIncentivePricing: boolean;
	incentiveSubscriptionFee: number | null;
	incentiveExpirationDate: Date | null;
	isFullyEditable: boolean;
	includeSbaExclusion: boolean;
	successFeeCap: number | null;
	send30DayNotice: boolean;
	tailPeriodMonths: number | null;
}

export interface SubscriptionPaymentTerm {
	id: number;
	guid: string;
	amount: number;
	numberOfDays: number;
}

export type RefinanceBenefitType = keyof typeof RefinanceBenefitTypeMap;
export const RefinanceBenefitTypeMap = {
	IncrementAmountOnly: 'Incremental Amount Only',
	PercentDiscount: '% Discount',
};

export type CompanySubscriptionStatus = keyof typeof CompanySubscriptionStatusMap;
export const CompanySubscriptionStatusMap = {
	Pending: 'Pending',
	Active: 'Active',
	Renewed: 'Renewed',
	Canceled: 'Canceled',
	Inactive: 'Inactive',
};
